import FormControl from '@mui/material/FormControl';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import FormLabel from 'components/form/FormLabel';
import TextInput from 'components/form/TextInput';
import React from 'react';

const NameField = ({
  required,
  hasError,
  label,
  hint,
  value = {},
  margin,
  onChange,
}) => {
  const handleChange = (e) => {
    const { name, value: val } = e.target;
    const updatedValue = {
      ...value,
      [name]: val,
    };
    onChange(updatedValue);
  };

  return (
    <FormControl fullWidth required={required} margin={margin} error={hasError}>
      <Grid container columnSpacing={2}>
        {label && (
          <Grid item md={12}>
            <FormLabel label={label} />
          </Grid>
        )}
        <Grid item md={6}>
          <TextInput
            fullWidth
            hasError={hasError && !value?.first_name}
            helpText="First name is required"
            margin="none"
            name="first_name"
            onChange={handleChange}
            value={value.first_name}
            label="First Name"
          />
        </Grid>
        <Grid item md={6}>
          <TextInput
            fullWidth
            hasError={hasError && !value?.last_name}
            helpText="Last name is required"
            margin="none"
            name="last_name"
            onChange={handleChange}
            value={value.last_name}
            label="Last Name"
          />
        </Grid>
        {hint && (
          <Grid item md={12}>
            <Typography
              component="p"
              variant="caption"
              color="textSecondary"
              sx={{ pl: 2, pt: 0.5 }}
            >
              {hint}
            </Typography>
          </Grid>
        )}
      </Grid>
    </FormControl>
  );
};

export default NameField;
